import { render, staticRenderFns } from "./SignUpRewardConfirm.vue?vue&type=template&id=d2d3055a&scoped=true"
import script from "./SignUpRewardConfirm.vue?vue&type=script&lang=js"
export * from "./SignUpRewardConfirm.vue?vue&type=script&lang=js"
import style0 from "./SignUpRewardConfirm.vue?vue&type=style&index=0&id=d2d3055a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d3055a",
  null
  
)

export default component.exports